export default "__VITE_ASSET__1d46c3b4__"